import { render, staticRenderFns } from "./RewardLogBody.vue?vue&type=template&id=7c99229e&"
import script from "./RewardLogBody.vue?vue&type=script&lang=ts&"
export * from "./RewardLogBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports